export const comparePlansConstantText = {
  backButtonText: 'Back to All Plans',
  enrollText: 'Enroll',
  ComparelabelLinkText: 'Click here',
  planLinkLabel: 'Plan links',
  benefitText: 'Benefits',
};

export const ResourcesBenefit = {
  label: 'Resources',
  type: 'document',
  value: null,
};
